<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Activar Factura Electrónica</small>
                <v-select v-model="data.fel"
                    :items="options"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.fel ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.fel" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Tipo de Identificación</small>
                <v-select v-model="data.identification_type"
                    :items="identifications"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.identification_type ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.identification_type" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Identificación</small>
                <input type="text" class="form-control form-control-sm" v-mask="format" v-model="data.identification" :class="errors.identification ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.identification" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Correo Electrónico de Factura Electrónica</small>
                <input type="email" class="form-control form-control-sm" v-model="data.email_fel" :class="errors.email_fel ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.email_fel" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group mb-2">
                <small class="input-title">Código de Actividad</small>
                <input type="text" class="form-control form-control-sm" v-model="data.activity_code_fel" v-mask="'####.#'" :class="errors.activity_code_fel ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.activity_code_fel" :key="index">{{ error }}</small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['data', 'errors'],
    computed: {
        format: function(){
            let format = ''
            if(this.data.identification_type == 1){
                format = '0#-####-####'
            } else if(this.data.identification_type == 2){
                format = '3-###-######'
            } else if(this.data.identification_type == 3){
                format = '1############'
            } else {
                format = '9#################'
            }
            return format
        }
    },
    data(){
        return{
            identifications: [
                { value: 1, text: 'Cédula Nacional' },
                { value: 2, text: 'Cédula Juridica' },
                { value: 3, text: 'Cédula de Residencia (DIMEX)' },
                { value: 4, text: 'Pasaporte' },
            ],
            options: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
        }
    },
}
</script>
